import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ClientForm from "../components/ClientForm";
import {
  cardCreatedSuccessfully, cardCreationFailed,
  createCardRequest
} from "../actions/clientsActions";
import { translateServerError } from "../helpers/core";
import createCardHttpHandler, {
  Contact,
  CreateCardRequest,
  GrainVolume
} from "../apiClient/Card/Create";

class AddClientPage extends Component {
  render() {
    const {
      addClient: add,
      initData,
      error,
      loading,
      redirect_url
    } = this.props;

    if (redirect_url.length > 0) {
      window.location.href = redirect_url;
      return;
    }
    return (
      <ClientForm
        initData={initData}
        onSubmit={add}
        serverError={error}
        clientSaving={loading}
      />
    );
  }
}

const addClientRequest = (dispatch, data) => {

  dispatch(createCardRequest());

  createCardHttpHandler.create(new CreateCardRequest(
      data.client.name || null,
      data.client.type || null,
      data.client.email || null,
      data.client.address || null,
      data.client.lat || null,
      data.client.lon || null,
      data.client.geo_id || null,
      data.client.date_will_call || null,
      data.client.call_aim || null,
      data.client.additional_info || null,
      data.client.area_full || null,
      data.client.contract || false,
      data.client.vat || 1,
      data.client.contacts.map((contactData) => new Contact(
          contactData.name,
          contactData.phone,
          contactData.email,
          contactData.isVisible,
      )),
      data.client.websites,
      data.client.filials.map((filialData) => filialData.id),
      data.client.cultures.map((grainData) => new GrainVolume(
          grainData.culture_id,
          grainData.price,
          grainData.volume,
          grainData.quality_comment,
      )),
      data.client.categories || [],
      )
  ).subscribe(
      (response) => {
        dispatch(cardCreatedSuccessfully(response.data.redirect_url));
      },
      (error) => {
        dispatch(cardCreationFailed(error.error.join("\n")));
      })
}

AddClientPage.propTypes = {
  initData: PropTypes.object,
  addClient: PropTypes.func.isRequired,
  error: PropTypes.string,
  loading: PropTypes.bool,
  redirect_url: PropTypes.string
};

const mapStateToProps = state => ({
  initData: state.webInterface.initData,
  error: translateServerError(state.clients.error),
  loading: state.clients.loading || false,
  redirect_url: state.clients.redirect_url || ""
});

const mapDispatchToProps = dispatch => ({
  addClient: data => addClientRequest(dispatch, data)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddClientPage);



// WEBPACK FOOTER //
// ./containers/AddClientPage.js